import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    container: {
        position: 'absolute',
        zIndex: 999,
        width: '100%',
        height: '100%',
    },
    mobileContainer: {
        zIndex: 2,
    },
    minimizedContainer: {
        padding: '0px 30px',
        borderBottomRightRadius: 30,
        borderBottomLeftRadius: 30,
    },
    maximizedContainer: {
        padding: '0px 20px',
    },
    dominantSpeakerContainer: {
        position: 'absolute',
        bottom: '10%',
        right: '2.5%',

        '& img': {
            margin: '10px 0px',
            borderRadius: '50%',
            width: 50,
            height: 50,
        },
    },

    dominantSpeakerMobileContainer: {
        position: 'absolute',
        top: '10vh',
        right: '5vw',

        '& img': {
            margin: '10px 0px',
            borderRadius: '50%',
            width: 50,
            height: 50,
        },
    },
    dominantSpeakerText: {
        color: 'white',
        textAlign: 'center',
    },
    iconButton: {
        margin: '0px 5px',
        maxWidth: 100,
        maxHeight: 100,
        '& img': {
            maxWidth: 25,
            maxHeight: 25,
        },
    },
    icon: {
        margin: 0,
        padding: 0,
        width: 30,
        height: 30,
        color: 'white',
    },
});
